import { Component } from '@angular/core';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';

@Component({
  templateUrl: './update.component.html',
  styleUrls: ['./update.component.css'],
})
export class UpdateComponent {

  form: FormGroup = new FormGroup({
    driver: new FormGroup({
      id: new FormControl(0, [Validators.required, Validators.min(1)]),
      email: new FormControl(''),
      mdmid: new FormControl('', [Validators.required]),
    }),
    mineDocuments: new FormArray([]),
  })

  get driverFormGroup(): FormGroup {
    return this.form.controls.driver as FormGroup;
  }
  get mineDocumentsFormArray(): FormArray {
    return this.form.controls.mineDocuments as FormArray;
  }

  constructor(
  ) {
    // this.driverFormGroup.value
    this.form.valueChanges.subscribe({
      next: (values) => {
      },
    });

  }

}
